// @ts-nocheck
import React, { Component, createRef } from "react";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import ReasonLogIcon from "../reasonLogIcon";
import HistoricalVersionModal from "./historicalVersionModal";
import NormalToolTip from "../toolTip";
import store from "store/index";

const modalRef = createRef();
export default class HistoricalVersionComponent extends Component {
  /**
   * Success callback for getHistoricalFiles api
   */
  getHistoricalVersionSuccess = (response: any) => {
    if (modalRef.current !== null) {
      // @ts-ignore
      modalRef.current.handleSetVersionData(response);
      // @ts-ignore
      modalRef.current.handleChangeVersionModal(response);
    }
  };

  /**
   * Error callback for getHistoricalFiles api
   */
  getHistoricalVersionError = (error: any) => {
    console.log(error);
    // @ts-ignore
    this._alertError("Get Historcal Version Failed!");
  };

  /**
   * Get history version data from api
   * @param {string} fileId
   * @param {string} fileKey
   * @param {string} businessId
   */
  handleGetHistoricalVersion = (fileId: any, fileKey: any, businessId: any) => {
    const state = store.getState();
    const params = {
      FileKey: fileKey,
      FileID: fileId,
      FlowBusinessID: businessId,
      // @ts-ignore
      ProcedureID: state.procedureDetailPage.procedureId,
    };
    ProcedureDetailService.getHistoricalFiles(
      params,
      (response: any) => this.getHistoricalVersionSuccess(response),
      this.getHistoricalVersionError
    );
  };

  render() {
    // @ts-ignore
    const { fileId, fileKey, flowBusinessId } = this.props;
    return (
      <>
        <NormalToolTip
          element={
            <div data-testid={`historical-version-icon-${fileId}`}>
              <ReasonLogIcon
                className="historicalVersionIcon"
                onClick={() => this.handleGetHistoricalVersion(fileId, fileKey, flowBusinessId)}
              />
            </div>
          }
          title="View History Version"
          placement="right"
          color="#3E6CB5"
        />
        {/* @ts-ignore */}
        <HistoricalVersionModal
          handleCloseVersionModal={(this as any).handleCloseVersionModal}
          ref={modalRef}
        />
      </>
    );
  }
}
